// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"ef319613","228":"9a8d47dc","272":"8ec62dfe","287":"de53be3e","352":"ed3db6cc","549":"754ac649","666":"b2c655b9","816":"c92cf609","837":"94bb0938","930":"2dadf3ab"}[chunkId] + ".chunk.js";
};